import React from 'react';
import { useDictionary } from '../../../../../utilities/hooks/UseDictionary';
import PropTypes from 'prop-types';
import caretLeft from '../../../../../assets/icons/ic_caret_left.svg';
import MultipeCustomGttdCheckbox from '../../../common/MultipeCustomGttdCheckbox';

const SelectFilterGttd = (props) => {
    const dictionary = useDictionary();

    const backToFilterList = () => {
        props.setShowBoxFilter(true);
        props.setShowGttdSelectbox(false);
    }
    
    return (
        <div className="group-filter-hidden inputs">
            <a href="#" onClick={backToFilterList} className="back-to-filter-list">
                <img src={caretLeft} />
                <span>{dictionary.back}</span>
            </a>
            {Object.keys(props.gttdStaticsValues).map((gttd) => (
                <MultipeCustomGttdCheckbox
                    label={props.gttdStaticsValues[gttd].text}
                    checbboxObj={props.statusCheckeds}
                    itemKey={gttd}
                    onFilterStatusSelected={props.onFilterStatusSelected}
                    setEnableScheduling={props.setEnableScheduling}
                    filterCount={props.filterCount}
                    key={gttd}
                />
            ))}
        </div>
    );
}

SelectFilterGttd.propTypes = {
	setShowBoxFilter: PropTypes.func,
	setShowGttdSelectbox: PropTypes.func,
	setEnableScheduling: PropTypes.func,
    statusCheckeds: PropTypes.array,
    filterCount: PropTypes.number,
    onFilterStatusSelected: PropTypes.func,
    gttdStaticsValues: PropTypes.object
};

export default SelectFilterGttd;